<template>
  <div
    class="overlay-loading"
    :style="{
      position: position,
    }"
  >
    <PrmProgressSpinner
      style="width: 64px; height: 64px"
    />
  </div>
</template>

<script setup lang="ts">
import PrmProgressSpinner from '@NitrexGroup/primevue/progressspinner';
import {
  CSSProperties,
} from 'vue';

withDefaults(defineProps<{
  loading?: boolean,
  position?: CSSProperties['position'],
}>(), {
  loading: true,
  position: 'fixed',
});
</script>

<style scoped lang="scss">
@use '../../styles/z-index.scss';

.overlay-loading {
  z-index: z-index.$progress-bar;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto;
  background-color: rgb(0 0 0 / 40%);
}
</style>
